var ANALYTICS_WRAPPER_CLASS = 'search-results-analytics-container';
var ANALYTICS_SECTION_CLASS = 'search-results-analytics-section';
var ANALYTICS_RESULT_CLASS = 'search-result-analytics-result';
var SEARCH_BAR_ENGAGED_EVENT = 'Search Bar Engaged';
var SEARCH_BAR_ENGAGED_EVENT_FOCUS_LABEL = 'Focus';
var SEARCH_BAR_ENGAGED_EVENT_TYPED_LABEL = 'Typed';
var SEARCH_RESULT_CLICKED = 'Search Result Clicked';
var SEARCH_RESULT_RIGHT_CLICKED = 'Search Result Right-Clicked';
var RECENT_SEARCH_QUERY_SUBMITTED_LABEL = 'Recent Search';
var POPULAR_SEARCH_QUERY_SUBMITTED_LABEL = 'Popular Search';
var SUGGESTED_SEACH_QUERY_SUBMITTED_LABEL = 'Suggested Search';

export { ANALYTICS_RESULT_CLASS, ANALYTICS_SECTION_CLASS, ANALYTICS_WRAPPER_CLASS, POPULAR_SEARCH_QUERY_SUBMITTED_LABEL, RECENT_SEARCH_QUERY_SUBMITTED_LABEL, SEARCH_BAR_ENGAGED_EVENT, SEARCH_BAR_ENGAGED_EVENT_FOCUS_LABEL, SEARCH_BAR_ENGAGED_EVENT_TYPED_LABEL, SEARCH_RESULT_CLICKED, SEARCH_RESULT_RIGHT_CLICKED, SUGGESTED_SEACH_QUERY_SUBMITTED_LABEL };
//# sourceMappingURL=analyticsConstants.js.map
